import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { cinemaShows } from "@/mocks/cinemas";
import { getMovieById } from "@/lib/movie";

export default function CinemaPreview() {
  const preview = cinemaShows.slice(0, 4);

  return (
    <section className="w-full bg-background-100">
      <div className="w-full max-w-[1360px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <SectionHeading
          title="影院上映动态"
          subtitle="实时汇总各大影院的排片与场次信息（演示数据）"
          moreTo="/cinema"
          moreLabel="查看全部影院动态"
        />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {preview.map((show) => {
            const movie = getMovieById(show.movieId);
            if (!movie) return null;
            return (
              <div
                key={show.id}
                className="flex gap-4 rounded-lg bg-background-50 border border-background-200 p-4"
              >
                <Link to={`/detail/${movie.id}`} className="shrink-0 cursor-pointer">
                  <div className="w-[86px] h-[126px] rounded-md overflow-hidden bg-background-200">
                    <img
                      src={movie.poster}
                      alt={`${movie.title} 电影海报`}
                      title={`${movie.title} - 影院上映`}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </Link>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2 text-xs text-foreground-500">
                    <i className="ri-map-pin-line text-accent-500"></i>
                    {show.city}
                    <span className="w-px h-3 bg-background-300"></span>
                    {show.hallType}
                  </div>
                  <h3 className="mt-1.5 font-semibold text-foreground-950 truncate">{movie.title}</h3>
                  <p className="text-xs text-foreground-600 mt-1 truncate">{show.cinemaName}</p>
                  <div className="flex flex-wrap gap-1.5 mt-2.5">
                    {show.showtimes.slice(0, 4).map((t) => (
                      <span
                        key={t}
                        className="text-[11px] px-2 py-0.5 rounded bg-primary-50 text-primary-700"
                      >
                        {t}
                      </span>
                    ))}
                    {show.showtimes.length > 4 && (
                      <span className="text-[11px] px-2 py-0.5 rounded bg-background-100 text-foreground-500">
                        +{show.showtimes.length - 4} 场
                      </span>
                    )}
                  </div>
                  <p className="text-[11px] text-foreground-400 mt-2">
                    {show.showDate} · 场次信息仅为演示示例
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}